// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"4cb2d84b","422":"7aa0e7f8","461":"27efe9e3","469":"dfb502f5","735":"18907ab9","787":"57a00088","916":"80801d11"}[chunkId] + ".chunk.js";
};